
import { Watch, Component, TenantService, BaseTLTableComponent, AxiosResponse, tlISODateTimeToLocalNoSecondsString, checkBoxToString } from "../../../Infrastructure/CorBase/CoreBase";

	 
	@Component
	export default class TenantListBase extends BaseTLTableComponent {		
		selectedTenantId: number = 0;
		tenantService: TenantService = new TenantService();

		protected deleteObjectBase(idTenant: any) {
			return this.tenantService.delete(idTenant).then(res => {
				this.fetchData();
			});
		}

		showAllertToDeleteClick(itemsSelected: any) {
			this.showAlertBeforeActionClickBase(itemsSelected, this.$t('userList.messageQuestionMain').toString());
			//this.showAlertBeforeActionClick(itemsSelected, this.$t('tenant.messageQuestionMain').toString());
		}

		callActionClick() {
			this.isBusy = true;
			this.tenantService.delete(this.itemsSelected).then(() => this.fetchData()).catch(error => {
				var errorMessage = this.$t('tenant.errorDelete').toString();
				super.showAlertModalWithErrorMessageList(errorMessage);
				this.isBusy = false;
			}).catch(error => {
				this.showAlertModalWithErrorMessage(this.$t('errorsall.errorMessageDeleteTenant').toString());
				this.isBusy = false;
			});
		}

		itemsAnswer = [
			{ value: this.$t('global.answerYes').toString(), text: this.$t('global.answerYes').toString() },
			{ value: this.$t('global.answerNo').toString(), text: this.$t('global.answerNo').toString() }];

		fetchData() {
			super.fetchData();
		}

		fetchDataFromServer(): Promise<AxiosResponse<any>> {
			return this.tenantService.getAll();
		}

		//zatím nepotrebujeme
		fetchRefreshDataFromServer(): Promise<AxiosResponse<any>> {
			return this.fetchDataFromServer();
		}

		refreshItems(items: any[], refreshData: any[]) {
			return items;
		}

		prepareItems(items: any[]) {
			for (var i = 0; i < items.length; i++) {
				items[i].creationDate3 = items[i].creationDate;
				items[i].creationDate2 = items[i].creationDate;		
				items[i].isDeletedText = this.$t(checkBoxToString(items[i].isDeleted)).toString();
			}
		}

		setFields() {
			this.fields = [
				{ key: 'identifier', label: this.$t('tenant.fieldIdentif'), trans: 'tenant.fieldIdentif', sortable: true, class: 'text-left', optional: false, thClass: 'firstColumnTable' },
				{ key: 'shortName', label: this.$t('tenant.fieldAbbreviation'), trans: 'tenant.fieldAbbreviation', sortable: true, class: 'text-left', visible: false, optional: true },
				{ key: 'name', label: this.$t('tenant.fieldName'), trans: 'tenant.fieldName', sortable: true, class: 'text-left', visible: true, optional: false, design: 'detail' },
				
				{ key: 'description', label: this.$t('tenant.fieldDescription'), trans: 'tenant.fieldDescription', sortable: true, class: 'text-left', visible: false, optional: true },		

				{ key: 'companyName', label: this.$t('tenant.fieldCompanyName'), trans: 'tenant.fieldCompanyName', sortable: true, class: 'text-left', visible: false, optional: true },	

				{ key: 'creationDate', label: this.$t('tenant.fieldDate'), trans: 'tenant.fieldDate', sortable: true, class: 'text-left ', formatter: (x: Date) => tlISODateTimeToLocalNoSecondsString(x), visible: true, optional: false },

				{ key: 'trialEndDate', label: this.$t('tenant.fieldTrialEnd'), trans: 'tenant.fieldTrialEnd', sortable: true, class: 'text-left ', formatter: (x: Date) => tlISODateTimeToLocalNoSecondsString(x), visible: false, optional: true },
				{ key: 'eraseDate', label: this.$t('tenant.fieldEraseDate'), trans: 'tenant.fieldEraseDate', sortable: true, class: 'text-left ', formatter: (x: Date) => tlISODateTimeToLocalNoSecondsString(x), visible: false, optional: true },
				{ key: 'deletedDate', label: this.$t('tenant.fieldDeleteDate'), trans: 'tenant.fieldDeleteDate', sortable: true, class: 'text-left ', formatter: (x: Date) => tlISODateTimeToLocalNoSecondsString(x), visible: false, optional: true },
				{ key: 'isDeletedText', label: this.$t('tenant.fieldIsDeleted'), trans: 'tenant.fieldIsDeleted', sortable: true, class: 'text-left', visible: true, optional: false, show: true },
				{ key: 'idStateText', label: this.$t('tenant.fieldState'), trans: 'tenant.fieldState', sortable: true, class: 'text-left', visible: true, optional: false },
			
				{ key: 'idStateIdentifier', label: 'Neviditelny', sortable: false, class: 'text-left', optional: true, visible: false, show: false },
				{ key: 'actions', label: this.$t('tenant.fieldActions'), trans: 'tenant.fieldActions', class: 'text-right', thClass: 'lastColumnTable' },
			]
		};

			//filtry
		setfilters(value: any) {
			if (value != null && value[0].lang == this.filters[0].lang) {
				this.filters = value;
			}
			else {
				this.filters = [
					{ key: 'isDeletedText', label: this.$t('tenant.fieldIsDeleted'), trans: 'tenant.fieldIsDeleted', selected: true, value: this.$t('global.answerNo').toString(), type: 'text', useOwnEnumsSend: true, useOwnEnumsSendArray: this.itemsAnswer },
					{ key: 'identifier', label: this.$t('tenant.filterIdentif'), trans: 'tenant.filterIdentif', selected: false, value: true, type: 'text', refItem: 'identifier', lang: this.$store.state.currentLanguage },
						{ key: 'name', label: this.$t('tenant.filterName'), trans: 'tenant.filterName', selected: false, value: null, type: 'text' },
					{ key: 'shortName', label: this.$t('tenant.fieldAbbreviation'), trans: 'tenant.fieldAbbreviation', selected: false, value: null, type: 'text' },
					{ key: 'description', label: this.$t('tenant.filterDescription'), trans: 'tenant.filterDescription', selected: false, value: null, type: 'text' },
					{ key: 'creationDate2', label: this.$t('tenant.filterDateFrom'), trans: 'tenant.filterDateFrom', selected: false, value: null, type: 'datetime', moreThan: true, refItem: 'creationDate' },
					{ key: 'creationDate3', label: this.$t('tenant.filterDateTo'), trans: 'tenant.filterDateTo', selected: false, value: null, type: 'datetime', moreThan: false, refItem: 'creationDate' }
				];
				var activeTypeEnums = { key: 'ENU_COR_Tenant_State', label: 'AAA doplnit', selected: true, value: 'AAA doplnit', type: 'text', group: true, groupId: 'idStateIdentifier', groupName: this.$t('global.filterNotShowType').toString(), headName: this.$t('tenant.fieldState'), trans: 'tenant.fieldState', isNegative: true };

				super.loadFiltersEnumList([ activeTypeEnums]);
			}
		}

		//ukázka vlastní akce pro jeden řádek
		actionSigleRow(value: any) {
		}

		//ukázka vlastní akce pro více řádků
		actionMultiRow(value: any) {
		}

		//@ts-ignore
		@Watch('$store.state.currentLanguage')
		changeFieldsAfterChangeLanguageD(value: boolean, oldValue: boolean) {
			this.setfilters(null);
		}


	};